import React from 'react'
import { cn } from '@amusnet/react-ui'
import { useTranslation, TranslationKey } from '@amusnet/translations/react'
import { formatCurrency } from '@amusnet/amusnet-common'

const STATUS_KEY: Record<string, TranslationKey> = {
    READY: 'common.ready',
    PLAYING: 'common.playing',
    PAUSED: 'common.paused',
}

const STATUS_BADGE_CLASS: Record<string, string> = {
    READY: 'bg-[#1F1F1F] text-ultra-green border border-ultra-green rounded-md',
    PLAYING: 'bg-ultra-green text-black border border-ultra-green rounded-md',
    PAUSED: 'bg-ultra-amber text-black border border-ultra-amber rounded-md',
}

const UltraPlayStatsRow: React.FC<{
    totalBet: number
    totalWin: number
    status: string
    currency: string
    hideCents: boolean
    isPortrait?: boolean
    isLandscape?: boolean
}> = ({ totalBet, totalWin, status, currency, hideCents, isLandscape }) => {
    const { t } = useTranslation()

    return (
        <div
            className={cn(
                'flex items-center gap-3 flex-shrink-0',
                isLandscape ? 'px-[60px] pt-[26px] pb-2.5' : 'px-[60px] py-2'
            )}
        >
            <div className="flex-1">
                <div className="text-[24px] font-bold leading-[24px] tracking-[0.01em] mb-[10px] uppercase text-ultra-label">
                    {t('gameui.totalBet')}
                </div>
                <div className="flex items-baseline gap-[6px]">
                    <span className="text-[30px] font-black leading-[36px] text-white">
                        {formatCurrency(totalBet, { hideCents })}
                    </span>
                    <span className="text-[20px] font-bold leading-[24px] text-white">{currency}</span>
                </div>
            </div>
            <span
                className={cn(
                    'px-[16px] py-[4px] text-[24px] font-bold leading-[24px] tracking-[0.01em] uppercase flex-shrink-0',
                    STATUS_BADGE_CLASS[status]
                )}
            >
                {t(STATUS_KEY[status])}
            </span>
            <div className="flex-1 text-right">
                <div className="text-[24px] font-bold leading-[24px] tracking-[0.01em] mb-[10px] uppercase text-ultra-label">
                    {t('gameui.totalWin')}
                </div>
                <div className="flex items-baseline justify-end gap-[6px]">
                    <span className="text-[30px] font-black leading-[36px] text-white">
                        {formatCurrency(totalWin, { hideCents })}
                    </span>
                    <span className="text-[20px] font-bold leading-[24px] text-white">{currency}</span>
                </div>
            </div>
        </div>
    )
}

export default UltraPlayStatsRow
